<template>
  <div v-if="error.length" class="error">
    Please correct the following errors:
    <ul>
      <li v-for="(err, index) in error" :key="index">{{ err }}</li>
    </ul>
  </div>

  <div class="cell small-12">
    <h1>Pro-Rata Calculations</h1>
    <p>When an employee joins, leaves, has a change in salary, or otherwise has a change that affects their pay partway through a pay period, their pay may need to be pro-rated to ensure they are paid correctly for each portion of the period.</p>
    <p>Different companies use different methods to calculate pro-rated pay. Please confirm how you would like us to calculate this for your employees.</p>
    </div>
    <div class="cell small-12">
        <form class="fieldset" @submit.prevent> 

        <label for="prorationMethod">Starter and Leaver Pro-Ration Calculations</label>
        <select
          id="prorationMethod"
          v-model="props.formData.reducedPeriodProrationMethod"
          required
        >
          <option disabled>
            Please select an option
          </option>
          <option
            v-for="opt in REDUCEDPERIOD_PRORATIONMETHODS"
            :key="opt.value"
            :value="opt.value"
          >
            {{ opt.label }}
          </option>
        </select>

        <p class="help-panel" v-if="REDUCEDPERIOD_PRORATIONMETHODS.find(o => o.value === props.formData.reducedPeriodProrationMethod)">
          {{ REDUCEDPERIOD_PRORATIONMETHODS.find(o => o.value === props.formData.reducedPeriodProrationMethod).description }}
        </p>



        </form>



        <form class="fieldset" @submit.prevent> 

        <label for="salaryProrationMethod">Salary Change Pro-Ration Calculations</label>
        <select
          id="salaryProrationMethod"
          v-model="props.formData.salaryProrationMethod"
          required
        >
          <option disabled>
            Please select an option
          </option>
          <option
            v-for="opt in SALARY_PRORATIONMETHODS"
            :key="opt.value"
            :value="opt.value"
          >
            {{ opt.label }}
          </option>
        </select>

        <p class="help-panel" v-if="SALARY_PRORATIONMETHODS.find(o => o.value === props.formData.salaryProrationMethod)">
          {{ SALARY_PRORATIONMETHODS.find(o => o.value === props.formData.salaryProrationMethod).description }}
        </p>



        </form>


    </div>



</template>


<script setup>

import { ref, onMounted, watch } from 'vue'
import { REDUCEDPERIOD_PRORATIONMETHODS, SALARY_PRORATIONMETHODS } from '@/helpers/constants';

const error = ref([]);

const props = defineProps({
  formData: Object
})




const validateStep = () => {

  error.value = [];

  const selected = !!(props.formData && (REDUCEDPERIOD_PRORATIONMETHODS.some(o => o.value === props.formData.reducedPeriodProrationMethod) || SALARY_PRORATIONMETHODS.some(o => o.value === props.formData.salaryProrationMethod)));

  if (!selected) {
    error.value.push('Please select proration methods.');
    return false;
  }

  return true;
}



const executeStep = async () => {
  return true;
}



onMounted(() => {

});

defineExpose({ validateStep, executeStep });

</script>